/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FreeNightMatchCoverage } from './FreeNightMatchCoverage';
import {
    FreeNightMatchCoverageFromJSON,
    FreeNightMatchCoverageFromJSONTyped,
    FreeNightMatchCoverageToJSON,
    FreeNightMatchCoverageToJSONTyped,
} from './FreeNightMatchCoverage';

/**
 * One matched FNC × property pair. The FE renders a badge per property.
 * @export
 * @interface FreeNightMatch
 */
export interface FreeNightMatch {
    /**
     * vervotech_property_id this match applies to (matches the request id)
     * @type {number}
     * @memberof FreeNightMatch
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {FreeNightMatchCoverage}
     * @memberof FreeNightMatch
     */
    coverage: FreeNightMatchCoverage;
    /**
     * Top-up points cost when coverage=top_up; null otherwise
     * @type {number}
     * @memberof FreeNightMatch
     */
    topUpCost?: number | null;
    /**
     * Short user-facing string, e.g. "Your Cat 1-7 cert covers this hotel"
     * @type {string}
     * @memberof FreeNightMatch
     */
    badge: string;
    /**
     * id of the FNC that produced this match (for FE attribution / linking)
     * @type {string}
     * @memberof FreeNightMatch
     */
    matchedCreditId: string;
    /**
     * Loyalty program of the matched credit, e.g. "World of Hyatt"
     * @type {string}
     * @memberof FreeNightMatch
     */
    programName: string;
}



/**
 * Check if a given object implements the FreeNightMatch interface.
 */
export function instanceOfFreeNightMatch(value: object): value is FreeNightMatch {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('coverage' in value) || value['coverage'] === undefined) return false;
    if (!('badge' in value) || value['badge'] === undefined) return false;
    if (!('matchedCreditId' in value) || value['matchedCreditId'] === undefined) return false;
    if (!('programName' in value) || value['programName'] === undefined) return false;
    return true;
}

export function FreeNightMatchFromJSON(json: any): FreeNightMatch {
    return FreeNightMatchFromJSONTyped(json, false);
}

export function FreeNightMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNightMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'],
        'coverage': FreeNightMatchCoverageFromJSON(json['coverage']),
        'topUpCost': json['top_up_cost'] == null ? undefined : json['top_up_cost'],
        'badge': json['badge'],
        'matchedCreditId': json['matched_credit_id'],
        'programName': json['program_name'],
    };
}

export function FreeNightMatchToJSON(json: any): FreeNightMatch {
    return FreeNightMatchToJSONTyped(json, false);
}

export function FreeNightMatchToJSONTyped(value?: FreeNightMatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'coverage': FreeNightMatchCoverageToJSON(value['coverage']),
        'top_up_cost': value['topUpCost'],
        'badge': value['badge'],
        'matched_credit_id': value['matchedCreditId'],
        'program_name': value['programName'],
    };
}

